module.exports = __webpack_public_path__ + "static/media/NIH07071.43dad202.jpg";